export const clientCode: string="ERSRIMEMBER";